import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-secondary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <h3 className="text-xl font-bold">Mughal Ainak Mahal</h3>
              <p className="text-sm text-gray-300">Premium Eyewear Shop</p>
            </div>
            <p className="text-gray-300 mb-4">
              Your trusted partner for quality eyewear and professional eye care services in Mughalpura, Lahore.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/1FKg6XzAT6/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary bg-opacity-20 hover:bg-primary hover:bg-opacity-30 text-primary hover:text-white p-3 rounded-lg transition-all duration-300 transform hover:scale-105 font-semibold"
                aria-label="Follow us on Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/mughal.ainak.mahal?igsh=MXJkODQxYzF0czZvYg=="
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary bg-opacity-20 hover:bg-primary hover:bg-opacity-30 text-primary hover:text-white p-3 rounded-lg transition-all duration-300 transform hover:scale-105 font-semibold"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/eyeglasses" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Eyeglasses
                </Link>
              </li>
              <li>
                <Link to="/sunglasses" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Sunglasses
                </Link>
              </li>
              <li>
                <Link to="/lenses" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Lenses
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-300 hover:text-white transition-colors duration-200">
                  Reviews
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">Prescription Glasses</li>
              <li className="text-gray-300">Sunglasses</li>
              <li className="text-gray-300">Contact Lenses</li>
              <li className="text-gray-300">Eye Examinations</li>
              <li className="text-gray-300">Frame Repairs</li>
              <li className="text-gray-300">Lens Replacement</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 mb-3">
                <MapPin className="w-5 h-5 text-primary" />
                <span className="text-gray-300">Mughalpura, Lahore, Punjab, Pakistan</span>
              </div>
              <div className="flex items-center space-x-3 mb-3">
                <Phone className="w-5 h-5 text-primary" />
                <a href="tel:+923136261452" className="text-gray-300 hover:text-white">0313 626 1452</a>
              </div>

              <div className="flex items-center space-x-3">
                <Clock className="w-5 h-5 text-primary" />
                <span className="text-gray-300">Mon-Sat: 9AM-11PM, Sun: 12AM-6PM</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex justify-start">
            <p className="text-gray-300 text-sm">
              © 2024 Mughal Ainak Mahal. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 